export const GET_HUBSPOT_TICKETS = 'GET_HUBSPOT_TICKETS'
export const GET_HUBSPOT_TICKET = 'GET_HUBSPOT_TICKET'
export const CREATE_HUBSPOT_TICKET = 'CREATE_HUBSPOT_TICKET'
export const UPDATE_HUBSPOT_TICKET = 'UPDATE_HUBSPOT_TICKET'
export const DELETE_HUBSPOT_TICKET = 'DELETE_HUBSPOT_TICKET'
export const REPLY_HUBSPOT_TICKET = 'REPLY_HUBSPOT_TICKET'
